module.exports = __webpack_public_path__ + "img/logo_white.d9d5069c.svg";